import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { BaseNonMatchingCell, CellRendererParams } from "../base-non-matching-cell";
import {
  AgAddressesComponent
} from "@shared/components/grid/ag-cells/common/ag-addresses/ag-addresses.component";
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { Address } from "../../../../../../../models/address/address";
import { EntityType } from "@models/common/entity-type.enum";

@Component({
  selector: 'app-ag-non-matching-address-cell',
  standalone: true,
  imports: [
    AgAddressesComponent,
    AgActionIconButtonComponent
  ],
  templateUrl: 'ag-non-matching-address-cell.component.html',
  styleUrl: 'ag-non-matching-address-cell.component.scss'
})
export class AgNonMatchingAddressCellComponent extends BaseNonMatchingCell implements ICellRendererAngularComp {
  addresses = signal<Address[]>([]);

  override updateCell(params: CellRendererParams): boolean {
    this.addresses.set([params.data?.address].filter(Boolean) as Address[]);
    return super.updateCell(params);
  }

  override getIsMatches(): boolean {
    if (this.params.data?.relatedToEntityType != EntityType.Company) return true;

    return super.getIsMatches();
  }
}
